import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

import ContinentMenuItem from '../ContinentMenuItem/ContinentMenuItem';
import SearchOverlay from '@components/ui/SearchOverlay/SearchOverlay';
import Card from '@components/ui/Card/Card';

import styles from './ContinentMenu.module.scss';
import Props from './ContinentMenu.props';

const ContinentMenu = ({ continents }: Props) => {
  const [isSearchOverlayOpen, setSearchOverlayOpen] = useState(false);

  return (
    <Card hasBackground>
      <ul className={styles.ContinentMenu}>
        {continents.map((continent, id) => (
          <ContinentMenuItem
            {...continent}
            noIndex={id !== 0}
            key={continent.href}
            className={styles.ContinentMenuItem}
          />
        ))}
        <ContinentMenuItem
          className={styles.SearchWrapper}
          onClick={() => setSearchOverlayOpen(true)}>
          <FontAwesomeIcon icon={faSearch} className={styles.SearchIcon} />
        </ContinentMenuItem>
      </ul>
      <SearchOverlay
        isOpen={isSearchOverlayOpen}
        onCloseClick={() => setSearchOverlayOpen(false)}
      />
    </Card>
  );
};

export default ContinentMenu;
